import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider
} from '@mui/material';

const ColorBox = ({ className }) => (
  <Box
    className={className}
    sx={{
      width: 20,
      height: 20,
      borderRadius: 0.5,
      mr: 1,
      border: '1px solid #999'
    }}
  />
);

const LegendItem = ({ colorClass, text }) => (
  <Box display="flex" alignItems="center" mb={1}>
    <ColorBox className={colorClass} />
    <Typography variant="body2">{text}</Typography>
  </Box>
);

const Section = ({ title, children }) => (
  <>
    <Typography variant="subtitle1" fontWeight="bold" mt={2} mb={1}>
      {title}
    </Typography>
    {children}
    <Divider sx={{ my: 2 }} />
  </>
);

const ColorLegendResetsDialog = ({ open, onClose, classes }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Diccionario de Colores</DialogTitle>

      <DialogContent dividers>

        {/* FILA INICIAL */}
        <Section title="Fila Inicial">
          <LegendItem
            colorClass={classes.rowBlue}
            text="Reset Inicial (no se evalúan metas)"
          />
        </Section>

        {/* MPG */}
        <Section title="MPG">
          <LegendItem
            colorClass={classes.cellBrightGreen}
            text="Igual o mayor a la meta."
          />
          <LegendItem
            colorClass={classes.cellYellow}
            text="Hasta 1 abajo de la meta."
          />
          <LegendItem
            colorClass={classes.cellRed}
            text="1 o más abajo de la meta."
          />

          <Box sx={{ mt: 1 }}>
            <Typography variant="caption" color="text.secondary">
              Para revisar metas por clase, favor de revisar la pantalla de Metas.
            </Typography>
          </Box>
        </Section>

        {/* IDLE */}
        <Section title="Idle %">
          <LegendItem
            colorClass={classes.cellBrightGreen}
            text="Igual o menor a 32%"
          />
          <LegendItem
            colorClass={classes.cellYellow}
            text="Mayor a 32% y menor o igual a 35%"
          />
          <LegendItem
            colorClass={classes.cellRed}
            text="Mayor a 35%"
          />
        </Section>

        {/* CRUISE */}
        <Section title="Cruise Ctrl %">
          <LegendItem
            colorClass={classes.cellBrightGreen}
            text="Igual o mayor a 70%"
          />
          <LegendItem
            colorClass={classes.cellYellow}
            text="Mayor o igual a 50% y menor que 70%"
          />
          <LegendItem
            colorClass={classes.cellRed}
            text="Menor a 50%"
          />
        </Section>

        {/* TOP GEAR */}
        <Section title="Top Gear %">
          <LegendItem
            colorClass={classes.cellBrightGreen}
            text="Igual o mayor a 90%"
          />
          <LegendItem
            colorClass={classes.cellYellow}
            text="Mayor o igual a 80% y menor a 90%"
          />
          <LegendItem
            colorClass={classes.cellRed}
            text="Menor a 80%"
          />
        </Section>

      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ColorLegendResetsDialog;